import React from 'react';
import { Button, Divider } from 'antd';
import { motion, AnimatePresence } from 'framer-motion';
import { sectionVariants } from './animations';

const AnglersGuestsSection = ({
  collapseOpen,
  dateSearchState,
  increment,
  decrement,
  withAnimation = true,
}) => {
  const content = (
    <div className='pd-10'>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 16,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className='gMedium'>
            <div className='fs-15 grey-900'>Angler(s)</div>
            <div className='fs-12 grey-700'>or Guest(s) for accommodation</div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <Button
              shape='circle'
              onClick={() => decrement('anglers')}
              size='small'
              disabled={dateSearchState?.anglers <= 1}
            >
              –
            </Button>
            <div className='gMedium fs-16'>{dateSearchState?.anglers}</div>
            <Button
              shape='circle'
              onClick={() => increment('anglers')}
              size='small'
            >
              +
            </Button>
          </div>
        </div>
      </div>

      <Divider style={{ margin: '12px 0' }} />

      {/* Non-Angling Guests */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <div className='gMedium fs-15'>Non Angling Guest(s)</div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <Button
            shape='circle'
            onClick={() => decrement('nonAnglers')}
            size='small'
            disabled={dateSearchState?.nonAnglers <= 0}
          >
            –
          </Button>
          <div className='gMedium fs-16'>{dateSearchState?.nonAnglers}</div>
          <Button
            shape='circle'
            onClick={() => increment('nonAnglers')}
            size='small'
          >
            +
          </Button>
        </div>
      </div>
    </div>
  );

  if (!withAnimation) {
    return collapseOpen === 'who' ? content : null;
  }

  return (
    <AnimatePresence>
      {collapseOpen === 'who' && (
        <motion.div
          initial='closed'
          animate='open'
          exit='closed'
          variants={sectionVariants}
          style={{ overflow: 'hidden' }}
        >
          {content}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AnglersGuestsSection;
